'use strict';

var Driver = global.WebSocket || global.MozWebSocket;
if (Driver) {
  module.exports = undefined;
} else {
  module.exports = undefined;
}